import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { TileStructureParser } from "@src/cloud-connect/blueprint/dashboards/entities/tile-structure-parser";
import { getTileCollection } from "@src/cloud-connect/dependency-injection-container/get-tile-collection";
import { applyBlueprint } from "@src/cloud-connect/use-cases/apply-blueprint";
import { findSelectedBlueprintUseCase } from "@src/cloud-connect/blueprint/use-cases/find-selected-blueprint-use-case";
import { RootState } from "@src/reducers/store";
import {
  updateAutoMatchBlueprintModalContentShown,
  updateSelectedAutoMatchBlueprint,
  updateShowAutoMatchBlueprintModal,
} from "@src/reducers/your-reducer";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useApplyAutoMatchBlueprintContentHook = () => {
  const dispatch = useDispatch();

  const selectedAutoMatchBlueprint = useSelector(
    (state: RootState) =>
      state.yourSlice.autoMatchBlueprintModal.selectedBlueprint,
  );

  const machineStructureData = useSelector(
    (state: RootState) => state.yourSlice.editStructurePageTransferData,
  );

  const [currentStructure, setCurrentStructure] =
    useState<BlueprintsArrayObjectTypes>();
  const [proposedBlueprintStructure, setProposedBlueprintStructure] = useState<
    BlueprintsArrayObjectTypes | undefined
  >();

  const handleBackButtonClick = () => {
    dispatch(updateAutoMatchBlueprintModalContentShown("find"));
    dispatch(updateSelectedAutoMatchBlueprint(undefined));
  };

  const closeModal = () => {
    dispatch(updateShowAutoMatchBlueprintModal(false));
    dispatch(updateAutoMatchBlueprintModalContentShown("find"));
    dispatch(updateSelectedAutoMatchBlueprint(undefined));
  };

  const handleApplyBlueprint = () => {
    applyBlueprint(proposedBlueprintStructure);
    dispatch(updateShowAutoMatchBlueprintModal(false));
    dispatch(updateAutoMatchBlueprintModalContentShown("find"));
    dispatch(updateSelectedAutoMatchBlueprint(undefined));
  };

  useEffect(() => {
    if (machineStructureData) {
      setCurrentStructure({
        id: "",
        name: machineStructureData.nodeset.name,
        created_at: machineStructureData.nodeset.created_at,
        author: machineStructureData.name,
        organization: "",
        description: "",
        verified: false,
        updated_at: null,
      });
    }

    if (selectedAutoMatchBlueprint) {
      findSelectedBlueprintUseCase(selectedAutoMatchBlueprint.id).then(
        (selectedBlueprintResponse) => {
          setProposedBlueprintStructure(selectedBlueprintResponse);
          const tileCollection = getTileCollection();
          if (selectedBlueprintResponse.dashboard?.data?.tiles?.length) {
            const tileParser = new TileStructureParser(
              selectedBlueprintResponse.dashboard.data,
              false,
            );
            tileCollection.setTiles(tileParser.getTiles());
          } else {
            tileCollection.setTiles([]);
          }
        },
      );
    }
  }, [machineStructureData]);

  return {
    currentStructure,
    proposedBlueprintStructure,
    selectedAutoMatchBlueprint,
    handleBackButtonClick,
    closeModal,
    handleApplyBlueprint,
  };
};
